/* eslint-disable no-await-in-loop */
import _ from 'lodash';
import colorHelper from '$$helpers/color';
import globalStore from '$$globalStore';
import EstimationWorker from '../../workers/EstimationWorker';

const ACTION_TYPES = {
  ASSIGN: 0,
  STATUS: 1,
  PRIORITY: 2,
  COLOR: 3,
  CUSTOM_COL: 4,
  // REMOVE: 5,
  // EXPAND_COLLAPSE: 6,
  // EXPAND_COLLAPSE_MULTIVIEW: 7,
  // CASCADE_SORT: 8,
};

const ACTION_TYPE_TO_DATA_COMPOSER = {
  [ACTION_TYPES.ASSIGN]: async (projectId, tasksIds, value) => {
    const resourcesIdsToAdd = value === '-1' ? [] : value.trim().split(',').map(e => parseInt(e, 10));

    const tasksResourcesToEstimate = tasksIds.map(taskId => ({
      task_id: +taskId,
      gantt_id: +projectId,
      resources: resourcesIdsToAdd.map(resource_id => ({ resource_id, value: null, valuePerDay: null })),
    }));

    const estimationWorkerData = await EstimationWorker.calculate(tasksResourcesToEstimate, 'changeTasks', 'updateTasksResourceEstimations');
    const tasksToUpdate = [];

    tasksIds.forEach(taskId => {
      const taskData = globalStore.getters['tasksModel/tasksByIds'][taskId];

      if (!taskData.id) {
        return;
      }

      const changedResources = [];
      const currentTaskResources = globalStore.getters['tasksModel/getResourcesForTask'](+projectId, +taskId);

      currentTaskResources.forEach(resource => {
        const actionItem = {
          resource_id: resource.resource_id,
        };

        if (resource.resource_tasks_id) {
          actionItem.customEstimation = [{
            resource_task_id: resource.resource_tasks_id,
            action: 'delete',
          }];
        }

        changedResources.push({ ...actionItem, action: 'delete' });
      });

      resourcesIdsToAdd.forEach(resourceId => {
        const resourceEstimation = _.get(estimationWorkerData.diff.resourceEstimations, [taskId, resourceId]);

        changedResources.push({
          resource_id: resourceId,
          value: resourceEstimation ? +resourceEstimation.value : 0,
          action: 'insert',
        });
      });

      if (changedResources.length) {
        tasksToUpdate.push({ id: +taskId, changedResources });
      }
    });

    return tasksToUpdate;
  },
  [ACTION_TYPES.PRIORITY]: (projectId, tasksIds, value) => tasksIds.map(id => ({
    id,
    priority: Number(value),
  })),
  [ACTION_TYPES.COLOR]: (projectId, tasksIds, value) => tasksIds.map(id => ({
    id,
    color: colorHelper.getColorId(value),
  })),
  [ACTION_TYPES.STATUS]: async (projectId, tasksIds, value) => tasksIds.map(id => ({
    id,
    status: value,
  })),
  [ACTION_TYPES.CUSTOM_COL]: (projectId, tasksIds, customActions) => {
    const customFieldsChanges = customActions.map(customAction => ({
      customColumnId: customAction.actionId,
      value: customAction.actionPayload.value,
      isOptions: customAction.actionPayload.isOptions,
    }));

    return tasksIds.map(id => ({
      id,
      customFields: customFieldsChanges,
    }));
  },
};

const groupAndMerge = tasksChanges => tasksChanges.reduce((result, item) => {
  if (!result[item.id]) {
    result[item.id] = { id: item.id };
  }

  Object.assign(result[item.id], item);

  return result;
}, {});

export default async function (projectId, tasksIds, actions) {
  const composedTasksChangesPromises = actions.map(async action => {
    const composer = ACTION_TYPE_TO_DATA_COMPOSER[action.actionType];

    if (!composer) {
      throw Error(`No composer for action ${action.actionType}`);
    }

    if (action.actionType === ACTION_TYPES.CUSTOM_COL) {
      return composer(projectId, tasksIds, action.actionPayload);
    }

    return composer(projectId, tasksIds, action.actionPayload.value);
  });

  const composedTasksChangesArray = (await Promise.all(composedTasksChangesPromises)).flat();

  const mergedTasksChanges = groupAndMerge(composedTasksChangesArray);

  return Object.values(mergedTasksChanges);
}
